import { useState, useCallback } from 'react';

const STORAGE_KEY_FROM = 'analytics_from_date';
const STORAGE_KEY_TO = 'analytics_to_date';

function getDefaultFromDate(): string {
  const date = new Date();
  date.setMonth(date.getMonth() - 6);
  return date.toISOString().split('T')[0];
}

function getDefaultToDate(): string {
  return new Date().toISOString().split('T')[0];
}

function getStoredFromDate(): string {
  return localStorage.getItem(STORAGE_KEY_FROM) || getDefaultFromDate();
}

function getStoredToDate(): string {
  return localStorage.getItem(STORAGE_KEY_TO) || getDefaultToDate();
}

export function useDateRange() {
  const [fromDate, setFromDateState] = useState(getStoredFromDate);
  const [toDate, setToDateState] = useState(getStoredToDate);

  const setFromDate = useCallback((value: string) => {
    localStorage.setItem(STORAGE_KEY_FROM, value);
    setFromDateState(value);
  }, []);

  const setToDate = useCallback((value: string) => {
    localStorage.setItem(STORAGE_KEY_TO, value);
    setToDateState(value);
  }, []);

  const from = fromDate ? new Date(fromDate).toISOString() : undefined;
  const to = toDate ? new Date(toDate + 'T23:59:59').toISOString() : undefined;

  return {
    fromDate,
    toDate,
    setFromDate,
    setToDate,
    from,
    to,
  };
}
